export const BASE_URL = "http://third.apimydatacheck.com"


//utils/apiPaths.js
export const API_PATHS = {
    AUTH: {
        REGISTER: "/api/auth/register",//creer un nouveau utilisateur admin et membre
        LOGIN: "/api/auth/login",//authification des users et return le jwt 
        GET_PROFILE: "/api/auth/profile",//avoir les details utilisateurs
        FORGOT_PASS: "/api/auth/forgot-password",//pour reinitialiser le mot de passe 
        VERIFY_OTP: "/api/auth/verify-otp",//verifie l'authenticiter de l'OTP 
    },
    USERS: {
        GET_ALL_USERS: "/api/users/all",//recupere tout les utilisateurs (administrateur uniquement)
        GET_USER_BY_ID: (userId) => `/api/users/${userId}`,//recupere les users par ordre
        CREATE_USER: "/api/users",//creer un nouveau utilisateur (admin only)
        UPDATE_USER: (userId) => `/api/users/${userId}`,//modifier les details d'utilisateur
        DELETE_USER: (userId) => `/api/users/${userId}`,//supprimmer un utilisateur
    },

    TASKS: {
        GET_DASHBOARD_DATA:  "api/tasks/dashborad-data",//recuperer les informations dashboard
        GET_USER_DASHBOARD_DATA: "api/tasks/user-dashboard-data",//recuperer les informations user
        GET_ALL_TASKS: "/api/tasks",//recuperer toute les taches 
        GET_BY_ID: (taskId) => `/api/tasks/${taskId}`,//recupere les tache par id
        CREATE_TASK: "/api/tasks",//uniquement les admins 
        UPDATE_TASK: (taskId) => `/api/tasks/${taskId}`,//modifier une tache
        DELETE_TASK: (taskId) => `/api/tasks/${taskId}`,//supprimer une tache(admin)

        UPDATE_TASK_STATUS: (taskId) => `/api/tasks/${taskId}/status`,//mise a jour du status de la tache
        UPDATE_TODO_CHECKLIST: (taskId) => `/api/tasks/${taskId}/todo`,//mise a jour de ses taches
        GET_TASK_BY_PROJECT: (id) => `/api/tasks/project/${id}`,//recupere les tache par projet

    },
    REPORTS:{
          EXPORT_TASKS: "/api/reports/tasks",//telecharger toute les taches dans un fichier excel
          EXPORT_USER:   "/api/reports/users",//telecharger toute les users dans un fichier excel
    },
    IMAGE: {
        UPLOAD: "/api/upload/single ",//upload des images
    },
    PROJECT:{
        CREATE_PROJECT:"/api/project/create",
        UPDATE_PROJECT: (projectId) => `/api/project/${projectId}`,//modifier une tache
        DELETE_PROJECT: (projectId) => `/api/project/${projectId}`,//supprimer une tache(admin)
        GET_ALL_PROJECT: "/api/project/",//recuperer toute les taches 
        GET_ALL_BY_ID: (projectId) => `/api/project/${projectId}`,//recupere les tache par id

    },
    NOTIFY:{
        GET_NOTIFICATIONS:(userId)=>`/api/notify/notification/${userId}`,//recuperer les notifications
        MARK_AS_READ: (notificationId) => `/api/notify/${notificationId}/read`,//marquer comme lu
        DELETE_NOTIFICATION: (notificationId) => `/api/notify/${notificationId}`,//supprimer une notification
    }
}